import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { ToolsProvider } from '../provider/tools/tools';
import { AppComponent } from '../app.component';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
darkMode=false;
  constructor(private plt: Platform, private tool:ToolsProvider) {
    this.plt.ready().then(()=>{
      // Use matchMedia to check the user preference
     const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
      prefersDark.addListener(e=>{
        console.log('match: ',e);
         this.setAppTheme(e.matches)
      })
    });
   }


   toogleAppTheme(){
    //  this.darkMode = !this.darkMode;
    //  this.setAppTheme(this.darkMode)
   
   }

   setAppTheme(dark){
     this.darkMode= dark
       if(dark){
      document.body.setAttribute('color-theme','dark')
     
   }else{
    document.body.setAttribute('color-theme','light')
    
   }

   
   this.tool.saveStorage('Theme',this.darkMode);
    // this.darkMode=dark;
    // if(dark){
    //    document.body.classList.add("dark");
      
    //   console.log('candela');
    // }else{
    //   document.body.classList.remove("dark");
    //   console.log('morena');

    // }
   }
}
